import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import SupportServiceCategoryListForm from '@src/features/tenant/supportServices/categories/SupportServiceCategoryList';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function SupportServiceCategoryList() {
  return (
    <TenantRoleGuard
      canRoles={[TENANT_ROLE.ADMIN, TENANT_ROLE.CONTENT]}
      canService={[SERVICE.ENTERPRISE_PORTAL, SERVICE.DX_DIAGNOSIS]}
    >
      <TenantDefaultLayout>
        <CommonHelmet />
        <SupportServiceCategoryListForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default SupportServiceCategoryList;
